import * as types from './type'

export default {
  toggleCollapse: ({ commit }) => {
    commit(types.toggleCollapse)
  },
  dialogHide: ({ commit }) => {
    commit(types.dialogHide)
  },
  loadingStop: ({ commit }) => {
    commit(types.loadingStop)
  },
  switchPage : ({ commit }, payload) => {
    commit(types.SWITCH_PAGE, payload)
  }
}
